import branchIO from "web/script/embedded/branch-io";
import globals from "web/script/modules/globals";
import url from "web/script/utils/url";

const DEEP_LINK_PAGE_TYPES = new Set(["product"]);
const DEEP_LINK_PAGE_SUB_TYPES = new Set([
    "designer",
    "generic_category",
    "generic_subcategory",
    "designer_category",
    "designer_subcategory",
]);

export default {
    send(data) {
        data.forEach((event) => {
            if (event.type === "page_view") {
                branchIO("init", "key_live_glC2sUCTNt2zrOAWq49iTjnhsFblPHmX", {
                    metadata: {
                        trafficSource: getTrafficSource(),
                        lifeCycleStage: event.data.life_cycle_stage,
                        isReturningUser: event.data.returning_user,
                        country: event.data.country,
                        domain: event.data.domain,
                    },
                });

                let data = {
                    web_session_id: event.data.session_id,
                    page_type: event.data.page_type,
                };
                if (
                    DEEP_LINK_PAGE_TYPES.has(event.data.page_type) ||
                    DEEP_LINK_PAGE_SUB_TYPES.has(event.data.page_sub_type)
                ) {
                    data["$deeplink_path"] = globals.window.location.pathname;
                }
                branchIO("setBranchViewData", { data });
            }
        });
        // no way of waiting for this to be done
        return Promise.resolve();
    },
};

function getTrafficSource() {
    let params = url.parse(globals.window.location.href).searchParams;

    return params.get("atc_medium") == "cpc" || params.get("utm_medium") == "cpc"
        ? "paid"
        : "other";
}
